const c = {
  name: "LpmApac",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill-rule:evenodd;clip-rule:evenodd;fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M22.1,0.1c-0.5-0.1-1-0.1-1.5-0.1c-0.2,0-0.4,0-0.6,0h0C9,0,0,9,0,20c0,9.4,6.5,17.2,15.2,19.4
			c0.1,0,0.2,0,0.2,0.1c0.1,0,0.2,0,0.3,0.1l0.1,0.1l0,0c1.3,0.3,2.7,0.4,4.2,0.4c2.5,0,4.9-0.5,7.1-1.3c0.7,0.8,1.8,1.3,3,1.3
			c2.2,0,4-1.8,4-4c0-0.5-0.1-1-0.3-1.5c0.3-0.3,0.5-0.5,0.8-0.8C35,33.9,35.5,34,36,34c2.2,0,4-1.8,4-4c0-1.1-0.5-2.2-1.3-2.9
			c0.8-2.2,1.3-4.6,1.3-7.1C40,9.7,32.2,1.2,22.1,0.1z M35.1,31.8l-0.2-0.1c-0.5-0.4-0.9-1-0.9-1.6c0-0.5,0.2-1,0.6-1.4
			C35,28.2,35.5,28,36,28c0.3,0,0.7,0.1,1,0.3c0.6,0.4,1,1,1,1.7c0,1.1-0.9,2-2,2C35.7,32,35.3,31.9,35.1,31.8z M34,26.6
			c0.6-0.4,1.3-0.6,2-0.6c0.3,0,0.6,0,0.9,0.1c0.7-1.9,1.1-4,1.1-6.1c0-3.3-0.9-6.4-2.5-9.1L35.4,11c0.4,0.6,0.6,1.3,0.6,2
			c0,2.2-1.8,4-4,4c-1.4,0-2.7-0.8-3.4-1.9L26,15.9c0,0.1,0,0.1,0,0.2c0,0.7-0.2,1.4-0.6,2l1.5,1.5c0.6-0.4,1.3-0.6,2-0.6
			c2.2,0,4,1.8,4,4c0,0.7-0.2,1.4-0.6,2L34,26.6z M34.4,9.2C31.7,5.6,27.7,3,23,2.3v9.9c1,0.3,1.9,0.9,2.4,1.8l2.6-0.8
			c0-0.1,0-0.1,0-0.1c0-2.2,1.8-4,4-4c0.7,0,1.4,0.2,2,0.6L34.4,9.2z M20.9,2c0,0,0.1,0,0.1,0v10.1c-1.3,0.3-2.3,1.2-2.7,2.5
			L4.8,13.3L20.9,2z M17.1,2.2C11.6,3.1,7,6.5,4.3,11.2L17.1,2.2z M2.3,16.6C2.1,17.7,2,18.8,2,20c0,7.7,4.8,14.2,11.5,16.8
			L2.3,16.6z M17.2,37.8c0.9,0.1,1.8,0.2,2.8,0.2c2.1,0,4.2-0.4,6.1-1.1C26,36.6,26,36.3,26,36c0-0.5,0.1-1.1,0.3-1.5l-1.8-1.4
			C23.8,33.7,22.9,34,22,34c-0.6,0-1.1-0.1-1.6-0.3L17.2,37.8z M27.5,32.9c0.7-0.5,1.6-0.9,2.5-0.9c1,0,1.8,0.3,2.5,0.9
			c0.1-0.1,0.2-0.2,0.4-0.4C32.3,31.8,32,30.9,32,30c0-0.4,0.1-0.7,0.2-1.1c0.1-0.3,0.2-0.7,0.4-0.9L31,26.4c-0.6,0.4-1.3,0.6-2,0.6
			c-0.7,0-1.4-0.2-2-0.6L25.4,28c0.4,0.6,0.6,1.3,0.6,2c0,0.5-0.1,1-0.3,1.5L27.5,32.9z M28.3,37.1L28.3,37c-0.2-0.3-0.3-0.6-0.3-1
			c0-0.5,0.2-1,0.4-1.2c0.4-0.5,1-0.8,1.6-0.8c0.7,0,1.3,0.3,1.7,0.9c0.2,0.3,0.3,0.7,0.3,1.1c0,1.1-0.9,2-2,2
			C29.3,38,28.7,37.7,28.3,37.1z M34,13c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2s0.9,2,2,2C33.1,15,34,14.1,34,13z M19.6,26.8
			c0.7-0.5,1.5-0.8,2.4-0.8l0,0c0.7,0,1.4,0.2,2,0.6l1.5-1.5c-0.4-0.6-0.6-1.3-0.6-2s0.2-1.4,0.6-2L24,19.4c-0.6,0.4-1.3,0.6-2,0.6
			c-2,0-3.6-1.5-3.9-3.4L5.3,15.3L19.6,26.8z M15.7,36.5l3.2-4.1C18.3,31.8,18,30.9,18,30c0-0.6,0.1-1.1,0.4-1.6L5.3,18L15.7,36.5z
			 M24,16c0-0.2,0-0.4-0.1-0.5c-0.3-0.9-1-1.5-1.9-1.5c-1,0-1.9,0.8-2,1.8V16c0,1.1,0.9,2,2,2c0.5,0,1-0.2,1.4-0.6
			C23.8,17,24,16.5,24,16z M20.8,31.6C21,31.8,21.4,32,22,32c0.6,0,1.2-0.3,1.6-0.8C23.8,31,24,30.5,24,30s-0.2-1-0.6-1.4
			C23,28.2,22.5,28,22,28c-0.6,0-1.2,0.3-1.6,0.8C20.1,29.1,20,29.5,20,30C20,30.6,20.3,31.2,20.8,31.6z M27,23c0,0.5,0.2,1,0.6,1.4
			h0c0.8,0.8,2.1,0.8,2.8,0C30.8,24,31,23.5,31,23c0-1.1-0.9-2-2-2c-0.5,0-1,0.2-1.4,0.6C27.2,22,27,22.5,27,23z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as LpmApac
};
